import React, { useState, useMemo, useCallback, useEffect } from "react";
import { Table, Button, Input, Switch, Select, Dropdown, Checkbox, Tooltip } from "antd";
import { ControlOutlined, FilterOutlined, ClearOutlined, CopyOutlined } from "@ant-design/icons";
import columns from "./columns";
import apiService from "./data";
import NoDataComponent from "../common/NoDataComponent";
import VariantDrawer from "../VariantProductsDetailView/VariantDrawer";
import FullPageLoader from "../common/FullPageLoader";
import ErrorNotification from "../common/ErrorNotification";
import { exportToExcel } from "../MasterTable/exportToExcel";
import { useAuth } from "../UserAuth/AuthContext";
import common_api from "../../config/common_api";
import { triggerNotification } from "../common/notify";
const { Search } = Input;

const VariantTable = ({ globalList, setGlobalList }) => {
  const [data, setData] = useState([]);
  const [originaldata, setOriginaldata] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [slectedStore, setSlectedStore] = useState("Select Store");
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedDrawerdata, setSelectedDrawerdata] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [stores, setstores] = useState([]);
  const [isloader, setisloader] = useState(true);
  const [alert, setAlert] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visibleColumnKeys, setVisibleColumnKeys] = useState(columns.map(col => col.dataIndex));
  const [selectedFilter, setSelectedFilter] = useState(null);
  const isAnyFilterApplied = searchText || (slectedStore && slectedStore !== "Select Store") || selectedFilter;
  const { userData } = useAuth();
  const [copiedSku, setCopiedSku] = useState(null);

  // const [expandedRowCheckedKeys, setExpandedRowCheckedKeys] = useState([]);

  useEffect(() => {
    if (drawerVisible && originaldata.length > 0) {
      applyAllFilters();
    }
  }, [originaldata, drawerVisible]);

  const handleExport = () => {
    const selectedVariants = [];

    data.forEach(product => {
      if (product.variant_data) {
        product.variant_data.forEach(variant => {
          if (selectedRowKeys.includes(variant.variant_id)) {
            selectedVariants.push({
              ...variant,
              parent_bcSku: product.bcSku,
              parent_bcName: product.bc_name,
              parent_store: product.store,
              currency_symbol: product.currency_symbol,
              // active_status: product.is_purchase ? "1" : "0",
              active: product.is_purchase ? "1" : "0"
            });
          }
        });
      }
    });

    exportToExcel(selectedVariants);
  };
  const fetchData = async () => {
    const apiData = await apiService.apidata();   
    
    if (apiData.length > 0) {
      setGlobalList({ ...globalList, variant_datalist: apiData })
      setData(apiData);
      setOriginaldata(apiData);
      const anyFiltersApplied = isAnyFilterApplied;
      if (anyFiltersApplied) {
        applyAllFilters({ original: apiData });
      }
      setisloader(false);
    }
    const storelist = await apiService.get_stores();
    if (storelist.length > 0) {
      const allOption = { label: 'All', value: 'all' };
      setstores([allOption, ...storelist]);
    }
  };
  useEffect(() => {
    if(!globalList || !globalList.variant_datalist || globalList.variant_datalist.length<=0){
      fetchData();
    }
    // fetchData();
  }, []);
  
  useEffect(() => {
    if (globalList && globalList.variant_datalist) {
      setData(globalList.variant_datalist);
      setOriginaldata(globalList.variant_datalist);
      applyAllFilters({ original: globalList.variant_datalist })
      setisloader(false)
    }
  }, [globalList]);
  const openDrawer = useCallback((data, bc_name) => {
    const filteredData = originaldata.filter((item) =>
      item.bc_name.toLowerCase() == bc_name.toLowerCase() && item.key === data.key
    );

    setSelectedDrawerdata(filteredData[0]);
    setDrawerVisible(true);
  }, [originaldata])

  const closeDrawer = () => setDrawerVisible(false);
  const activeFiltersCount = [
    searchText !== '',
    slectedStore && slectedStore !== 'all' && slectedStore !== 'Select Store',
    selectedFilter !== null,
  ].filter(Boolean).length;
  const handleSearch = (value) => setSearchText(value);

  const handleStoreChange = (value) => setSlectedStore(value);

  const handleFilterChange = (value) => setSelectedFilter(value);

  const applyAllFilters = () => {
    const search = searchText;
    const store = slectedStore;
    const filter = selectedFilter;
    const original = originaldata;

    let filtered = [...original];

    if (store && store !== "all" && store !== "Select Store") {
      filtered = filtered.filter(item =>
        item.store.toLowerCase().includes(store.toLowerCase())
      );
    }

    if (search) {
      filtered = filtered.filter(item =>
        item.bc_name.toLowerCase().includes(search.toLowerCase()) ||
        item.bcSku.toLowerCase().includes(search.toLowerCase()) ||
        item.variant_data?.some(v => v.variant_sku?.toLowerCase().includes(search.toLowerCase()))||
        item.variant_data?.some(v => v.variant_values?.toLowerCase().includes(search.toLowerCase()))
      );
    }

    switch (filter) {
      case "Products not live":
        filtered = filtered.filter(item => item.active === 0);
        break;
      case "Products live":
        filtered = filtered.filter(item => item.active === 1);
        break;
      case "Enrichment pending":
        filtered = filtered.filter(item => item.enrichment === false);
        break;
      case "All":
        break;
    }

    setData(filtered);
    // setCurrentPage(1);
  };

  useEffect(() => {
    applyAllFilters();
  }, [searchText, slectedStore, selectedFilter, originaldata]);

  const handleAlert = async (type, title, message, isopen) => {
    setAlert({ type, title, message, isopen });
    setTimeout(() => setAlert({ isopen: false }), 100);
  };

  const handleToggleActive = useCallback(async (checked, key) => {
    setisloader(true);
    let filterdata = originaldata.find(item => item.key === key);
    let responsedata = await apiService.active_inactive_status(filterdata, checked, false);    
    if (responsedata) {
      let alldata = await common_api.set_all_madded_data_to_variables(globalList, responsedata)
      
      if (alldata) {
        await setGlobalList(alldata)
      }
      setisloader(false);
      triggerNotification(responsedata)
    }
    setisloader(false);
  }, [originaldata, fetchData]);

  const handleVariamtToggleActive = useCallback(async (checked, key, id) => {
    setisloader(true);
    let parent = data.find(item => item.key === key);
    let filterdata = parent?.variant_data?.find(initem => initem.id === id);
    filterdata.store = parent.store
    let responsedata = await apiService.active_inactive_status(filterdata, checked, true);
    if (responsedata) {
      let alldata = await common_api.set_all_madded_data_to_variables(globalList, responsedata)
      if (alldata) {        
        await setGlobalList(alldata)
      }
      setisloader(false);
      triggerNotification(responsedata)
    }
    setisloader(false);
  }, [data]);
  const handleVariantSave = (newVariants) => {
    const newData = newVariants.map((variant, index) => ({
      ...variant,
      key: `new-${Date.now()}-${index}`,
    }));
    setData(prev => [...newData, ...prev]);
    setOriginaldata(prev => [...newData, ...prev]);
  };

  const updatedColumns = useMemo(() => {
    return columns
      .filter(col => visibleColumnKeys.includes(col.dataIndex))
      .map((col) => {
        if (col.dataIndex === "active") {
          return {
            ...col,
            render: (_, record) => (
              <Switch
                checked={record.active}
                disabled={userData.data?.access !== "ALL"}
                onChange={async (checked) => await handleToggleActive(checked, record.key)}
              />
            )
          };
        }
        if (col.dataIndex === "bc_name") {
          return {
            ...col,
            render: (_, record) => (              
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  position: 'relative',
                }}
                onMouseEnter={(e) => {
                  const icon = e.currentTarget.querySelector('.copy-icon');
                  if (icon) icon.style.opacity = 1;
                }}
                onMouseLeave={(e) => {
                  const icon = e.currentTarget.querySelector('.copy-icon');
                  if (icon) icon.style.opacity = 0;
                }}
              >
                  <Button type="link" onClick={(e) => openDrawer(record, record.bc_name)}>
                  {record.bc_name}
                </Button>               
                <Tooltip title={copiedSku === record.bc_name ? "Copied" : "Copy"}>
                  <CopyOutlined
                    className="copy-icon"
                    onClick={() => {
                      navigator.clipboard.writeText(record.bc_name);
                      setCopiedSku(record.bc_name);
                      setTimeout(() => setCopiedSku(null), 1500);
                    }}
                    style={{
                      marginLeft: 6,
                      color: copiedSku === record.bc_name ? '#52c41a' : '#999',
                      cursor: 'pointer',
                      opacity: 0,
                      transition: 'opacity 0.3s ease, color 0.3s ease',
                    }}
                  />
                </Tooltip>
              </span>
            )
          };
        }
        if (col.dataIndex === "image") {
          return {
            ...col,
            render: (image) => <img src={image} alt="variant" width={40} height={40} />
          };
        }
        return col;
      });
  }, [handleToggleActive, visibleColumnKeys, openDrawer, copiedSku]);

  const handleColumnChange = (dataIndex) => {
    setVisibleColumnKeys((prevKeys) =>
      prevKeys.includes(dataIndex)
        ? prevKeys.filter((key) => key !== dataIndex)
        : [...prevKeys, dataIndex]
    );
  };

  const columnOptions = columns.map(col => ({
    label: col.title,
    value: col.dataIndex
  }));

  const columnMenu = {
    items: columns.map(col => ({
      key: col.dataIndex,
      label: (
        <Checkbox
          checked={visibleColumnKeys.includes(col.dataIndex)}
          onChange={(e) => handleColumnChange(col.dataIndex)}
        >
          {col.title}
        </Checkbox>
      ),
    })),
  };


  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: (selectedKeys) => {
  //     setSelectedRowKeys(selectedKeys);
  //   }
  // };

  return (
    <div>
      <div style={{ marginBottom: 16 }} className="TableFilterBox">
        <Select
          placeholder="Filter"
          style={{ width: 180 }}
          suffixIcon={<FilterOutlined style={{ color: "rgba(0, 0, 0, 0.88)" }} />}
          value={selectedFilter}
          className="filterSelect"
          onChange={handleFilterChange}
          options={[
            { value: "All", label: "All" },
            { value: "Products not live", label: "Products not live" },
            { value: "Products live", label: "Products live" },
            { value: "Enrichment pending", label: "Enrichment pending" }
          ]}
        />
        <Select
          placeholder="Stores"
          style={{ width: 120 }}
          value={slectedStore}
          options={stores}
          onChange={handleStoreChange}
        />
        <Search
          placeholder="Search by BC SKU or Name"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 270 }}
          allowClear
          enterButton
        />
        {isAnyFilterApplied && (
          <Button
            onClick={() => {
              setSearchText('');
              setSlectedStore('Select Store');
              setSelectedFilter(null);
              setData(originaldata);
              // setCurrentPage(1); // Optionally reset to page 1
            }}
            className="ClearAllFiltersBtn"

          >
            <ClearOutlined style={{ marginRight: 4 }} />
            {activeFiltersCount === 1 ? 'Clear Filters' : 'Clear Filters'}
          </Button>
        )}
        <Dropdown menu={{ ...columnMenu, className: 'ColumnMenuClass' }} trigger={["click"]} placement="bottomRight" className="TableSettings">
          <Button icon={<ControlOutlined />} />
        </Dropdown>
        <div className="RightBox">
          <Button type="primary" disabled={selectedRowKeys.length <= 0} onClick={handleExport}>
            Export Selected
          </Button>        
        </div>
      </div>

      <FullPageLoader isloader={isloader} />
      <ErrorNotification {...alert} />

      {data && data.length > 0 ? <Table
        columns={updatedColumns}
        dataSource={data}
        scroll={{ x: '100%', y: 500 }}
        expandable={{
          expandedRowRender: (record) => (
            <div className="ExpandBox" >
              {record.variant_data && record.variant_data.map((innrecord) => (
                <div className="ExpandRows" key={innrecord.variant_id || innrecord.id}>
                  <Checkbox
                    checked={selectedRowKeys.includes(innrecord.variant_id)}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      const newSelectedKeys = isChecked
                        ? [...selectedRowKeys, innrecord.variant_id]
                        : selectedRowKeys.filter((key) => key !== innrecord.variant_id); // <- fixed here

                      setSelectedRowKeys(newSelectedKeys);
                    }}
                    style={{ marginBottom: 12 }}
                  >
                  </Checkbox>
                  <div className="ExpandCol variantImageCol">
                    <div className="ExpandRowValue">
                      <div className="variantImagebox">
                        <img
                          src={innrecord.variant_image}
                          alt="product"
                          style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4 }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="ExpandCol">
                    <div className="ExpandRowName">Option</div>
                    <div className="ExpandRowValue">{innrecord.variant_values}</div>
                  </div>
                  <div className="ExpandCol">
                    <div className="ExpandRowName">Default Price</div>
                    <div className="ExpandRowValue">{record.currency_symbol}{innrecord.variant_default_price}</div>
                  </div>
                  <div className="ExpandCol">
                    <div className="ExpandRowName">BC Inventory</div>
                    <div className="ExpandRowValue">{record.inventory_tracking === "variant" ? innrecord.inventory_available : "NA"}</div>
                  </div>
                  <div className="ExpandCol">
                    <div className="ExpandRowName">SAP SKU</div>
                    <div className="ExpandRowValue">{innrecord.sap_data ? innrecord.sap_data.sap_sku : "NA"}</div>
                  </div>
                  <div className="ExpandCol">
                    <div className="ExpandRowName">SAP Name</div>
                    <div className="ExpandRowValue">{innrecord.sap_data ? innrecord.sap_data.product_name : "NA"}</div>
                  </div>
                  <div className="ExpandCol">
                    <div className="ExpandRowName">MSRP</div>
                    <div className="ExpandRowValue">{record.currency_symbol}{innrecord.variant_msrp}</div>
                  </div>
                  <div className="ExpandCol">
                    <div className="ExpandRowName">Sale Price</div>
                    <div className="ExpandRowValue">{record.currency_symbol}{innrecord.variant_sale_price}</div>
                  </div>
                  <div className="ExpandCol">
                    <div className="ExpandRowName">SAP MSRP</div>
                    <div className="ExpandRowValue">{record.currency_symbol}{innrecord.sap_msrp ? innrecord.sap_msrp.sku : 0}</div>
                  </div>
                  <div className="ExpandCol">
                    <div className="ExpandRowName">SAP Sale Price</div>
                    <div className="ExpandRowValue">{record.currency_symbol}{innrecord.sap_sale ? innrecord.sap_sale.sku : 0}</div>
                  </div>
                  <div className="ExpandCol">
                    <div className="ExpandRowName">Subscription</div>
                    <div className="ExpandRowValue">{innrecord.is_subscription ? "Yes" : "No"}</div>
                  </div>
                  <div className="ExpandCol">
                    <div className="ExpandRowName">Active</div>
                    {/* <div className="ExpandRowValue">{innrecord.purchasing_disabled ? "No" : "Yes"}</div> */}
                    <Switch
                      checked={!innrecord.purchasing_disabled}
                      onChange={async (checked) => await handleVariamtToggleActive(checked, record.key, innrecord.id)}
                    />
                  </div>
                  {/* <div className="ExpandCol">
                  <div className="ExpandRowName">Product/Variant ID::</div>
                  <div className="ExpandRowValue">{innrecord.variant_id}</div>
                </div> */}
                </div>))}

            </div>
          ),
          rowExpandable: (record) => !!record.variant_data,
          columnWidth: 48
        }}
        pagination={{
          current: currentPage,
          pageSize,
          total: data.length,
          onChange: (page, pageSize) => {
            setCurrentPage(page);
            setPageSize(pageSize);
          },
          showTotal: (total) =>
            `Total ${total} items${selectedRowKeys.length > 0 ? ` | Selected: ${selectedRowKeys.length}` : ''}`,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          position: ['bottomLeft']
        }}
        bordered
      /> : <div>
        <NoDataComponent />
      </div>}


      {drawerVisible && <VariantDrawer
        visible={drawerVisible}
        onClose={closeDrawer}
        selected_prod_data={selectedDrawerdata}
        onSave={handleVariantSave}
        setisloader={setisloader}
        onProductCreate={fetchData}
        globalList={globalList} setGlobalList={setGlobalList}
      />}
    </div>
  );
};

export default VariantTable;
